module.exports = __webpack_public_path__ + "img/instagram-icon.9f41e00c.svg";